import React from 'react';

import { Button } from 'antd';
import styled from '@emotion/styled';
import Scheduler from 'app/components/Scheduler';
import moment from 'moment';
import { Event, EventProps, ToolbarProps, View } from 'react-big-calendar';
import Dropdown from 'app/components/Dropdown';

const StyledScheduler = styled(Scheduler)`
  &.rbc-calendar {
    height: 500px;
  }
  overflow: hidden;
  .rbc-time-view {
    border: none;
    .rbc-today {
      background: #fff !important;
    }
  }

  .rbc-time-content,
  .rbc-time-header-gutter {
    display: none !important;
  }

  .rbc-time-header {
    height: 450px;
    .rbc-time-header-content {
      border-left: none;
    }
    .rbc-header {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      font-size: 16px;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0.005em;
      text-align: left;

      min-height: 50px;
      border-bottom: 0px;
      border-left: 0px;
      text-align: left;
      background: #fff !important;

      &.startDay:after {
        padding: 12px 0;
        color: #005eff;
        font-size: 12px;
        font-weight: 500;
        line-height: 14px;
        letter-spacing: 0.005em;
        text-align: left;

        content: '(Start day)';
      }
    }
  }
  .rbc-event {
    background: transparent;
    > div {
      > div {
        ${() => {
          return `.ant-space-item:not(:first-of-type) {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-right: 8px;
          }`;
        }}
      }

      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0.002em;
      text-align: left;
      color: rgba(35, 43, 58, 1);
    }
  }
  .rbc-day-bg {
    &:not(:first-of-type) {
      box-shadow: 0px 6px 10px 2px rgba(165, 178, 200, 0.3);
      box-shadow: 0px 2px 5px 0px rgba(165, 178, 200, 0.3);
    }
    &.startDay {
      border-left: 4px solid #005eff;
    }
    &.endDay {
      background: red;
    }
    &.inDay {
      background: red;
    }
    &.rbc-today {
      // border-left: 4px solid #005eff;
      background: rgba(240, 245, 255, 1) !important;
    }
  }
  .rbc-allday-cell {
    min-height: calc(100% - 60px);
  }
`;

const InspectorScheduler = (props: {
  value: Date | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  events: Array<Event>;
  selectedInspector: any;
  onChangeInspector: (values: any) => void;
  onRangChange?: (
    dates: Date[] | { start: Date; end: Date },
    view?: View
  ) => void;
  renderEvent: (event: EventProps) => React.ReactElement;
}) => {
  const [date, setDate] = React.useState(new Date());

  const onNavigate = React.useCallback(
    (newDate: Date) => setDate(newDate),
    [setDate]
  );
  const dayPropGetter = (valueDate: Date) => {
    const isBetween = (date: moment.Moment) => {
      return date.isBetween(
        moment(props.startDate),
        moment(props.endDate),
        'day',
        '()'
      );
    };
    let className = '';
    if (
      moment(valueDate).format('DDMMYYYY') ===
      moment(props.startDate).format('DDMMYYYY')
    ) {
      className = 'startDay';
    }
    if (
      moment(valueDate).format('DDMMYYYY') ===
      moment(props.endDate).format('DDMMYYYY')
    ) {
      className = 'endDay';
    }
    if (isBetween(moment(valueDate))) {
      className = 'inDay';
    }
    if (
      moment(valueDate).diff(moment(props.startDate), 'days') < 0 ||
      !className
    ) {
      return {
        style: {
          backgroundColor: '#fff'
        }
      };
    }

    return {
      className: className,
      style: {
        backgroundColor: 'rgba(240, 245, 255, 1)'
      }
    };
  };

  React.useEffect(() => {
    setDate(props.value || new Date());
  }, [props.value]);

  const renderToolbar = (toolbarProps: ToolbarProps) => {
    return (
      <Scheduler.Toolbar
        leftElement={
          <Dropdown.Inspector
            value={props.selectedInspector}
            onApply={props.onChangeInspector}
          ></Dropdown.Inspector>
        }
        {...toolbarProps}
        rightElement={
          <Button
            type="link"
            onClick={() => {
              setDate(props.value || new Date());
              toolbarProps.onNavigate('DATE', props.startDate);
            }}
          >
            Back to start day
          </Button>
        }
      ></Scheduler.Toolbar>
    );
  };
  return (
    <StyledScheduler
      date={date}
      onRangeChange={props.onRangChange}
      onNavigate={onNavigate}
      events={props?.events ?? []}
      dayPropGetter={dayPropGetter}
      defaultView="week"
      views={['day', 'week']}
      tooltipAccessor={() => {
        return '';
      }}
      components={{
        timeGutterWrapper: () => <></>,
        timeSlotWrapper: () => null,
        event: props.renderEvent,
        toolbar: renderToolbar,
        week: {
          header: (headerProps) => {
            return (
              <Scheduler.HeaderWeek {...headerProps}></Scheduler.HeaderWeek>
            );
          }
        }
      }}
    ></StyledScheduler>
  );
};

export default InspectorScheduler;
